import React from 'react';

class TerminalSearch extends React.Component {
  handleChange() {
    this.props.onUserInput(this.searchInput.value);
  }

  render() {
    return (
      <input
        className="form-control form-group"
        type="text"
        placeholder="Search"
        value={this.props.searchText}
        ref={
          function(input) {
            if (input) {
              this.searchInput = input;
            }
          }.bind(this)
        }
        onChange={this.handleChange.bind(this)}
      />
    );
  }
}

export default TerminalSearch;
